import React, { Component } from 'react';
import { get } from 'lodash';
import Accent from '../../Accent';
import LinkButton from '../../LinkButton';
import { getUuidFromUrl, resizeTo } from '../../../lib/ucImage';
import { img } from '../../../lib/brand';
import styles from './styles.module.less';

var blogFallBack1 = img('BlogFallBack1.jpg');
var blogFallBack2 = img('BlogFallBack2.jpg');
var blogFallBack3 = img('BlogFallBack3.jpg');

class AuthorBlogs extends Component {
   renderBlogs = (blog, index) => {
      //get date
      let d = new Date(blog.date.toString());
      let date = d.toLocaleDateString('en-US', {
         month: 'long',
         day: 'numeric',
         year: 'numeric'
      });

      //parse image & html
      let img = '';
      let useAD = true;

      // if there is an image url like the cms shows, use that
      if (blog.image) {
         img = resizeTo(getUuidFromUrl(blog.image), 1000);
      } else if (blog.bloghero) {
         img = resizeTo(getUuidFromUrl(blog.bloghero), 1000);
      } else {
         //random int 1 to 3
         let n = Math.floor(Math.random() * 3);
         //fallback for feature img
         const fallBacks = [blogFallBack1, blogFallBack2, blogFallBack3];
         img = fallBacks[n];
         useAD = false;
      }
      const { author } = blog;
      const authorName = get(author, 'profile.name', 'the author');

      return (
         <a href={blog.slug} className={styles.blogItem} key={blog.id}>
            {useAD ? (
               <img className={styles.photoURL} data-blink-src={img} alt={blog.title} />
            ) : (
               <img className={styles.photoURL} src={img} alt={blog.title} />
            )}
            <div className={styles.content}>
               <div className={styles.date}>{date}</div>
               <div className={styles.author}>{`by ${authorName}`}</div>
               <div className={styles.blogTitle}>{blog.title}</div>
            </div>
         </a>
      );
   };

   render() {
      let { blogs } = this.props;
      if (!Array.isArray(blogs) || !blogs.length) return null;

      // assume we have at least one or we wouldn't be here
      const { author } = blogs[0];
      const authorName = get(author, 'profile.name', 'the author');
      const authorSlug = get(author, 'slug', '');

      return (
         <div className={styles.authorOuterContainer}>
            <div className={styles.authorContainer}>
               <h2>
                  Posts by {authorName} <Accent align="left" />{' '}
               </h2>
               <div className={styles.blogPanel}>{blogs.slice(0, 3).map(this.renderBlogs)}</div>
               {blogs.length > 3 && (
                  <div className={styles.ViewMore}>
                     <LinkButton label="View More" href={`/bay-equity-news${authorSlug}`} />
                  </div>
               )}
            </div>
         </div>
      );
   }
}
export default AuthorBlogs;
